import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

// ANT DESIGN
import { Input, Typography, Form, Col, Row } from "antd";

//PROJECT IMPORTS
import { BOM } from "../../../../../services/definedMethod";
import { labelConfig } from "../../../customer.config";
import GlobalDetailView from "../../../../../components/facilities/GlobalDetailView";

function GeneralTab(props) {
  const { customerDetails } = props;
  const isEntity = customerDetails?.legalForm?.id === 2;
console.log(customerDetails);
  const customerData = [
    {
      name: labelConfig.fullname,
      value: customerDetails.displayName,
    },
    {
      name: labelConfig.legalForm,
      value: customerDetails?.legalForm?.value,
    },
    {
      name: labelConfig.clientNo,
      value: customerDetails.accountNo,
    },
    {
      name: labelConfig.email,
      value: customerDetails.emailAddress,
    },
    {
      name: labelConfig.mobileNumber,
      value: customerDetails.mobileNo,
    },
    {
      name: labelConfig.relationshipManager,
      value: customerDetails.staffName ? customerDetails.staffName : "-",
    },
    {
      name: isEntity ? labelConfig.businessRegistrationNumber : labelConfig.externalID,
      value: customerDetails.externalId ? customerDetails.externalId : "-",
    },
    {
      name: labelConfig.taxID,
      value: customerDetails?.clientNonPersonDetails?.incorpNumber ? customerDetails?.clientNonPersonDetails?.incorpNumber : "-",
    },

    // {
    //   name: labelConfig.activationDate,
    //   value: BOM.DateTime(customerDetails?.activationDate, "only-date"),
    // },
    renderStatusDate(customerDetails?.status?.value),
  ];

  useEffect(() => {
    // getDetailById();
  }, []);

  function renderStatusDate(statusKey) {
    switch (statusKey?.toLowerCase()) {
      case "closed":
        return {
          name: labelConfig.closedDate,
          value: BOM.DateTime(customerDetails?.timeline?.closedOnDate, "only-date"),
        };
      case "active":
        return {
          name: labelConfig.activationDate,
          value: BOM.DateTime(customerDetails?.timeline?.activatedOnDate, "only-date"),
        };
      default:
        return {};
    }
  }

  return (
    <>
      <Form layout="vertical">
        <GlobalDetailView inputField={customerData} />
      </Form>
    </>
  );
}

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});
export default connect(mapStateToProps, null)(GeneralTab);
